import {
	fetchUserServicesWithUserRole,
	UserRole,
} from '@mairistem/finances-utils';

// Le type Service de finances-utils ne declare que identifiant/code/libelle,
// mais la route userServicesWithUserRole renvoie egalement, pour chaque
// service, le role de l'utilisateur courant sur ce service precis
export interface ServiceAvecRoleUtilisateur {
	identifiant: number;
	libelle: string;
	userRole?: { useGestionnaire: boolean };
}

/**
 * Services de l'exercice sur lesquels l'utilisateur peut agir : un
 * Gestionnaire ne peut choisir/agir que sur les services dont il est
 * effectivement gestionnaire, pas sur ceux auxquels il est seulement rattache
 * (ex: en tant que simple membre d'un autre service)
 */
export const fetchServicesUtilisables = async (
	identifiantExercice: number,
	userRole: UserRole,
): Promise<ServiceAvecRoleUtilisateur[]> => {
	const reponse = await fetchUserServicesWithUserRole(identifiantExercice);
	// fetchUserServicesWithUserRole met sa reponse en cache dans le
	// sessionStorage (cf @mairistem/finances-utils) : une entree y ayant ete
	// ecrite sous une forme non deballee (ex: { data: [...] } au lieu de [...],
	// par une version anterieure de la lib) resterait servie telle quelle
	// indefiniment. On se protege donc ici plutot que de faire confiance au
	// typage.
	const services: ServiceAvecRoleUtilisateur[] = Array.isArray(reponse)
		? (reponse as unknown as ServiceAvecRoleUtilisateur[])
		: ((reponse as unknown as { data?: ServiceAvecRoleUtilisateur[] })?.data ??
			[]);

	return userRole === UserRole.GESTIONNAIRE
		? services.filter((service) => service.userRole?.useGestionnaire)
		: services;
};

// Le controle des services habilites sur une ligne (ajout et import de
// demande, calcul) ne concerne qu'un Gestionnaire (ou Normal) en saisie par
// service : un pilote ou un administrateur agit sur toutes les lignes
export const isControleServicesHabilites = (
	saisieBudgetService: boolean,
	userRole: UserRole,
) => saisieBudgetService && userRole < UserRole.CHARGE_PILOTAGE;

// Aucun des services habilites (sur une ligne ou un perimetre) n'est un
// service de l'utilisateur
export const isAucunServiceCommun = (
	servicesHabilites: { identifiant: number }[],
	identifiantsServicesUtilisateur: number[],
) => {
	const identifiants = new Set(identifiantsServicesUtilisateur.map(Number));

	return !servicesHabilites.some((service) =>
		identifiants.has(Number(service.identifiant)),
	);
};
